import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "../../utils/axiosinstance";
import { enum_api_uri } from "common/hooks/utils/enum";
import { useAuthStore } from "user/store/useAuthStore";

interface Response {
    product_category_idx: number;
    category_name: string;
    category_image: string | null;
    wreath_option: true;
    union_option: true;
}

export const useGetCategory = (customer_idx: number, searchtxt?: string): UseQueryResult<Response[], Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    const url = `${enum_api_uri.user.get_category.replace(":customer_idx", customer_idx.toString())}${searchtxt ? `?search=category_name&searchtxt=${searchtxt}` : ""}`;

    return useQuery<Response[], Error>({
        queryKey: ["getCategory", customer_idx, searchtxt],
        queryFn: async () => {
            // const response = await axios.get(`${enum_api_uri.user.get_category.replace(":customer_idx", customer_idx.toString())}`, {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        enabled: !!customer_idx,

        // placeholderData: prevData => {
        //     if (prevData) {
        //         return {
        //             ...prevData,
        //         };
        //     }
        //     return undefined;
        // },
    });
};
